module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_12_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_12_after.jpg
// module id = 1179
// module chunks = 0